module.exports = __webpack_public_path__ + "static/media/wallet.bf7265f1.png";